import { useFlags } from "launchdarkly-react-client-sdk";
import { Navigate } from "react-router-dom";

import Breadcrumb from "components/atoms/Breadcrumb";
import Container from "components/atoms/Container";
import ManageSubscriptionPlatform from "components/organisms/ManageSubscription/ManageSubscriptionPlatform";
import NavHeader from "components/organisms/NavHeader";

import {
  NUTRITION_PLATFORM_GROWTH_SLUG,
  NUTRITION_PLATFORM_PRO_SLUG,
  NUTRITION_PLATFORM_SLUG,
  NUTRITION_PLATFORM_STARTER_SLUG,
  isValidProduct,
} from "utils/products";

const ManageSubscription = () => {
  const flags = useFlags();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const productQuery = params.get("product");

  if (!isValidProduct(productQuery)) {
    return <Navigate to="/not-found" />;
  }

  const pageList = [
    {
      label: "All Products",
      path: "/",
    },
    {
      label: "Manage Subscription",
    },
  ];

  if (!productQuery) {
    return <Navigate to="/" />;
  }

  // Only Nutrition AI Platform is subscribable. All other product slugs
  // redirect to the dashboard so deep links to legacy products
  // (e.g. /manage-subscription?product=nutrition-hub) can't bypass the
  // dashboard hiding.
  const isPlatformSlug =
    productQuery === NUTRITION_PLATFORM_SLUG ||
    productQuery === NUTRITION_PLATFORM_STARTER_SLUG ||
    productQuery === NUTRITION_PLATFORM_GROWTH_SLUG ||
    productQuery === NUTRITION_PLATFORM_PRO_SLUG;
  if (!isPlatformSlug) {
    return <Navigate to="/" />;
  }
  if (!flags["nutrition-ai-platform"]) {
    return <Navigate to="/" />;
  }

  return (
    <NavHeader>
      <Container>
        <Breadcrumb pageList={pageList} />
        <ManageSubscriptionPlatform />
      </Container>
    </NavHeader>
  );
};

export default ManageSubscription;
